export enum OnboardingUserType {
  New = "New",
  Returning = "Returning",
}
